// 'use strict'

import m from 'mithril'
import dictlist from './dictlist'
// var dictlist = require('./dictlist')
var search = require('./search')
var articles = require('./articles')
var util = require('../helpers/util')
var rest = require('./satni/satni.rest')
// require("babelify-es6-polyfill")
var btn = require('polythene/button/button')
var iconBtn = require('polythene/icon-button/icon-button')
var dictSVG = require('mmsvg/google/msvg/social/cake')

const satni = {}

function updateHitCount(dict, results) {
	results && dict.hits(results.length) || dict.hits(0)
	return results
}

const getElementSize = (el) => {
	const styles = window.getComputedStyle(el)
	// console.dir(styles)
	console.log(window.screen.width)
	console.log(window.screen.height)
}

satni.loadLocale = function() {
	var from = document.domain
  var locale = 'no'
  switch (true) {
    case /localhost/.test(from):
      locale = 'se'
      break;
    case /s[aá]tni\.org/.test(from):
    case /xn--stni-5na.org/.test(from):
      locale = 'se'
      break;
    case /b[aá]hko\.org/.test(from):
    case /xn--bhko-5na\.org/.test(from):
      locale = 'smj'
      break;
    case /baakoe\.org/.test(from):
      locale = 'sma'
      break;
    default:
    	locale = 'no'
  }

  mx.translate.configure({
    infix: 'locales/',
    suffix: '/app.json'
  })

	return mx.translate.use(locale)
}

satni.allDict =
	new dictlist.Dict({
		id: "all",
	    name: [
            {text: 'Alle ordbøker', lang: 'no'},
            {text: 'Visot sátnegirjjit', lang: 'se'},
            {text: 'Gaajhkh baakoegærjah', lang: 'sma'},
            {text: 'Divna báhkogirje', lang: 'smj'}
        ],
	    selected: true
	})

satni.controller = function() {
	var ctrl = this, cache = {}, error = m.prop("")

  ctrl.dictlist = m.prop([])

	rest.getDictList()
		  .then(function(data) {
				ctrl.dictlist(data)
				ctrl.dictlist().push(satni.allDict)
			})
	ctrl.results = m.prop([])
	ctrl.articles = m.prop([])
	ctrl.showLng = m.prop(false)
  ctrl.loading = m.prop(false)

	ctrl.showSearch = m.prop(true)

	ctrl.selectedDict = m.prop(satni.allDict)

	ctrl.getArticles = function(item) {
		return rest.getArticle(item)
            .then(ctrl.articles, ctrl.error)
    }

	ctrl.getter = function(item) {
        var promises = ctrl.dictlist().filter(function(dict) {
            return dict.id().indexOf(satni.allDict.id()) < 0  //0 is 'all'
        }).map(function(dict) {
        	return rest.query(item, dict.id())
    			.then(updateHitCount.curry(dict))
        })
        console.log("Sending requests...")
				ctrl.loading(true)
        return m.sync(promises)
	        .then((results) => {
	        	return results
	        })
	}

	ctrl.runSearch = util.debounce((term) => {
		term.length > 2 && ctrl.getter(term).then((resultset) => {
			ctrl.results([])
			for (var hits of resultset) {
				hits && ctrl.results(hits.concat(ctrl.results()))
                m.redraw(true)
			}

			if (ctrl.results().length > 0) {
				ctrl.results().sort(function(a,b) {return a.term.localeCompare(b.term)})
				ctrl.getArticles(ctrl.results()[0].term)
			}
			ctrl.loading(false)
		}) || ctrl.results([])
	}, 400)


	ctrl.decorator = function(item) {
		return m.component(btn, {
			content : item,
			tag : 'a',
			class : 'result-item',
			events : {
				onclick : () => {
					ctrl.getArticles(item)
					ctrl.showSearch(false)
				}
			}
		})
	}

	ctrl.filter = function(item, index) {
        // console.log("filter: " + item.dict + " == " + ctrl.selectedDict().id())
        if(ctrl.selectedDict().id() === "all")
            return 1
        else if(item.dict !== null)
            return item.dict.indexOf(ctrl.selectedDict().id()) > -1
        else
            return 0
    }
}

const lngList = [
	{
        id : 'no',
        label : 'Vis webappen på norsk'
    }, {
        id : 'se',
        label : 'Čájet webprográmmaža davvisámegillii'
    }, {
        id : 'sma',
        label : 'Vuesehth åarjelsaemein webappem'
    }, {
        id : 'smj',
        label : 'Webæhppa julevsámegiellaj'
    }
]

const lngSelect = {
	view: (ctrl, args) => {
		// return m.component(menu, {
		// 	target : 'lng_select',
		// 	offset : 0,
		// 	show : ctrl.showLng,
		// 	didHide : () => (ctrl.showLng(false)),
		// 	content : m.component(list, {
		// 		tiles : args.list.map(item => {
		// 			return m.component(listTile, {
		// 				label : item.label
		// 			})
		// 		})
		// 	})
		// })
		return m("select", {
            value: mx.translate.use(),
            onchange: m.withAttr("value", mx.translate.use)
        }, [
            args.list.map(function(item) {
                return m("option", { value: item.id }, item.label)
            })
        ])
	}
}

const dictIconBtn = m.component(iconBtn, {
	icon : {
		msvg : dictSVG
	},
	// events : {
	// 	onclick :
	// }
})

const desktopView = (ctrl) => {
	return m("div", [
    m(".row", [ m("p[style=font-size:36px;]",
			mx.translate('modules.localization.title') + ".org") ]),
    m(".row", [
  		m.component(dictlist, {
        items: ctrl.dictlist,
        binds: ctrl.selectedDict
      }),
   		m.component(search, {
        runSearch: ctrl.runSearch,
        data: ctrl.results,
        decorator: ctrl.decorator,
        filter: ctrl.filter,
        loading: ctrl.loading
      }),
    	m(".col-md-4", [
        m("span#lng_select[style=font-size:36px;]", {
          class: "glyphicon glyphicon-cog",
          onclick: ctrl.showLng.bind(ctrl,!ctrl.showLng())
        }),
        ctrl.showLng() ? m.component(lngSelect, {
          list: lngList
        }) : null,
        m.component(articles, {
          data: ctrl.articles,
          filter: ctrl.filter,
          dictlist: ctrl.dictlist
        })
    	])
  	])
	])
}

const mobileView = (ctrl) => {
	return m("div", { class : "row" }, [
		dictIconBtn,
		ctrl.showSearch() ?
		m.component(search, {
			runSearch: ctrl.runSearch,
			data: ctrl.results,
			decorator: ctrl.decorator,
			filter: ctrl.filter,
			loading: ctrl.loading
		}) :
		m("div", [
			m("a", {
				onclick : ctrl.showSearch.bind(ctrl,!ctrl.showSearch())
			}, "Back"),
			m.component(articles, {
				data: ctrl.articles,
				filter: ctrl.filter,
				dictlist: ctrl.dictlist
			})
		])
	])
}

const footer = {
    view: (ctrl) => {
        return m(".footer", {
            style: {
                position: "relative",
                bottom:"0"
            }
        }, [
            m("p.lead", [
                m("span", [m.trust(mx.translate('modules.localization.about1') + "<br/>")]),
                m("span", [m.trust(mx.translate('modules.localization.about2') + "<br/>")]),
                m("span", [m.trust(mx.translate('modules.localization.about3'))])
            ])
        ])
    }
}

satni.view = function(ctrl) {
	return m(".layout", {
		// config : el => {
		// 	getElementSize(el)
		// }
	},
	window.screen.width < 740 ? mobileView(ctrl) : desktopView(ctrl),
	footer
	)
}

export default satni
